export const BRANDS_ACTION_TYPES = {
  GET_BRANDS_GAMES: 'brands/getBrandsGames',
  CHOOSE_BRAND: 'brands/chooseBrand',
  SET_NO_BONUS_GAMES_MESSAGE_READ: 'brands/setNoBonusGamesMessageRead',
};
